import { Component, OnInit } from '@angular/core';
import { SidebarPanelComponent } from '../sidebar/sidebar-panel/sidebar-panel.component';
import { AppMessageService } from '../shared/app-message/app-message.service';
import { LandingPageTile } from '../shared/tiles/home-tile.model';
import { _ } from '../shared/utils';

@Component({
  selector: 'qm-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent extends SidebarPanelComponent implements OnInit {

  public selectedTab = 'automation-admin';

  constructor(protected appMessageService: AppMessageService) {
    super(appMessageService);
    this.componentName = ManagementComponent.getComponentName();
  }

  public static initTile(tile: LandingPageTile) {
    tile.description = _('Management');
    tile.icon = 'far fa-cog';
    tile.title = _('Management');
    tile.panel = ManagementComponent.getComponentName();
  }

  private static getComponentName(): string {
    return 'Management';
  }

  ngOnInit() {
  }
}
